import { render, staticRenderFns } from "./PrecisionPicker.vue?vue&type=template&id=208c4948&scoped=true"
import script from "./PrecisionPicker.vue?vue&type=script&setup=true&lang=js"
export * from "./PrecisionPicker.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PrecisionPicker.vue?vue&type=style&index=0&id=208c4948&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208c4948",
  null
  
)

export default component.exports